import { useEffect, useState } from "react";
import { parseDataBr } from "../components/ui/CalendarioCustomizado";

export interface PeriodoGlobal {
  inicio: string;
  fim: string;
}

export const CHAVE_PERIODO_GLOBAL_INICIO = "filtroDataInicioDash";
export const CHAVE_PERIODO_GLOBAL_FIM = "filtroDataFimDash";
const EVENTO_PERIODO_GLOBAL = "periodo-global-change";

function dataBrValida(valor: string): boolean {
  return !!parseDataBr(valor);
}

export function lerPeriodoGlobal(): PeriodoGlobal | null {
  if (typeof window === "undefined") return null;

  const inicio = String(localStorage.getItem(CHAVE_PERIODO_GLOBAL_INICIO) || "").trim();
  const fim = String(localStorage.getItem(CHAVE_PERIODO_GLOBAL_FIM) || "").trim();
  if (!dataBrValida(inicio) || !dataBrValida(fim)) return null;

  return { inicio, fim };
}

function notificarPeriodoGlobal() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(EVENTO_PERIODO_GLOBAL, {
      detail: lerPeriodoGlobal(),
    })
  );
}

export function salvarPeriodoGlobal(inicio: string, fim: string) {
  if (typeof window === "undefined") return;
  if (!dataBrValida(inicio) || !dataBrValida(fim)) return;

  localStorage.setItem(CHAVE_PERIODO_GLOBAL_INICIO, inicio);
  localStorage.setItem(CHAVE_PERIODO_GLOBAL_FIM, fim);
  notificarPeriodoGlobal();
}

export function limparPeriodoGlobal() {
  if (typeof window === "undefined") return;

  localStorage.removeItem(CHAVE_PERIODO_GLOBAL_INICIO);
  localStorage.removeItem(CHAVE_PERIODO_GLOBAL_FIM);
  notificarPeriodoGlobal();
}

export function inscreverPeriodoGlobal(listener: () => void) {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const aoAlterarStorage = (evento: StorageEvent) => {
    if (
      evento.key !== CHAVE_PERIODO_GLOBAL_INICIO &&
      evento.key !== CHAVE_PERIODO_GLOBAL_FIM &&
      evento.key !== null
    ) {
      return;
    }
    listener();
  };

  window.addEventListener("storage", aoAlterarStorage);
  window.addEventListener(EVENTO_PERIODO_GLOBAL, listener as EventListener);

  return () => {
    window.removeEventListener("storage", aoAlterarStorage);
    window.removeEventListener(EVENTO_PERIODO_GLOBAL, listener as EventListener);
  };
}

export function usePeriodoGlobal(): PeriodoGlobal | null {
  const [periodo, setPeriodo] = useState<PeriodoGlobal | null>(() => lerPeriodoGlobal());

  useEffect(() => inscreverPeriodoGlobal(() => setPeriodo(lerPeriodoGlobal())), []);

  return periodo;
}

export function usePeriodoGlobalToken(): string {
  const periodo = usePeriodoGlobal();
  return periodo ? `${periodo.inicio}-${periodo.fim}` : "todos-os-periodos";
}
